require('date-time-format-timezone');

export const longMonth = m =>
    new Intl.DateTimeFormat('ru', {
        timeZone: 'Europe/Moscow',
        month: 'long'
    }).format(new Date(2019, m));

export const shortMonth = m => longMonth(m).substr(0, 3);
